export const Props = () => ({
  //--------------------------------------------------------------------------
  //                    Тип кнопки (default, secondary, alert)
  //--------------------------------------------------------------------------
  type: {
    type: String,
    default: 'default',
    validator: (value) => {
      const allowedTypes = ['default', 'overlay', 'white-fill', 'white-fill-shadow'];
      if(allowedTypes.includes(value)){
        return true;
      } else{
        throw new Error(`Параметр 'type' в компоненте ButtonClose может содержать только значения: ${allowedTypes.join(', ')}`);
      }
    }
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //--------------------------------------------------------------------------
  //                   Объект селектора, который надо поднять вверх
  //--------------------------------------------------------------------------
  selector: {
    type: Object,
    required: true,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});